<template>
  <div class='logout-warning-backdrop'>
    <div class='logout-warning-container' v-if='otherTabsAvailable'>
      <div class='lw-ui-box'>
        <div class='lw-header'>Multiple active tabs detected</div>
        <div class='lw-body'>
          Multiple tabs are active. You will be logged out from all the open
          tabs and might loose unsaved data. Do you want to continue?
        </div>
        <div class='lw-btn-container'>
          <ejs-button
            id='btnConfirmSignout'
            cssClass='e-btn e-warning'
            v-on:click.native='continueSignout'
            >Yes</ejs-button
          >
          <ejs-button
            id='btnCancelSignout'
            cssClass='e-btn e-success'
            v-on:click.native='cancelSignout'
            >No, Go back</ejs-button
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AuthHelper from '../components/auth-helper';

export default {
  name: 'Logout',
  async created() {
    AuthHelper.broadcastSignoutPing(this.signoutResponseCallback);
  },
  mounted() {
    setTimeout(() => {
      if (!this.otherTabsAvailable) this.continueSignout();
    }, 500); // adding a delay to see if other tabs are active
  },
  data() {
    return {
      otherTabsAvailable: false,
    };
  },
  methods: {
    signoutResponseCallback(e) {
      if (e) this.otherTabsAvailable = true;
    },
    async continueSignout() {
      this.otherTabsAvailable = false;
      await AuthHelper.signUserOut();
      this.$router.push('/');
    },
    cancelSignout() {
      // Todo: Ideally logout function should be moved to navbar component and
      // display the warning as a popup message.
      // So when 'go back' is clicked user will stay on the same page
      this.otherTabsAvailable = false;
      this.$router.push('/');
    },
  },
};
</script>

<style>
.logout-warning-backdrop {
  width: 100%;
  height: 100%;
}

.lw-ui-box {
 width: 50%;
    padding: 30px;
    padding-bottom: 50px;
    margin: 30px auto;
border: 1px solid 3d8d8d8;
    box-shadow: 5px 11px 20px #d8d8d8;
}
.lw-header {
  background: #d7720a;
  padding: 12px;
  margin: 0px -10px;
  border-radius: 3px;
  color: white;
  text-align: center;
}
.lw-body {
  padding: 20px;
  color: #181313;
  text-align: justify;
}
.lw-btn-container {
  text-align: center;
}

.lw-btn-container > button {
  margin-left: 10px;
  margin-top: 30px;
}
</style>
